import {
    isExcludedScreen,
    type TSessionDialogContext,
    type TSessionDialogVerdict,
} from '@core/session-dialogs'

export const shouldShowConverterPromo = ({
    isFromGoogle,
    lcpRecorded,
    seenConverterPromo,
    screenId,
}: TSessionDialogContext): TSessionDialogVerdict => {
    if (isFromGoogle) {
        return false
    }

    if (!lcpRecorded) {
        return 'pending'
    }

    if (seenConverterPromo) {
        return false
    }

    return !isExcludedScreen(screenId)
}
